import { render, staticRenderFns } from "./confirm-reciept.vue?vue&type=template&id=aca095d0&scoped=true"
import script from "./confirm-reciept.vue?vue&type=script&lang=js"
export * from "./confirm-reciept.vue?vue&type=script&lang=js"
import style0 from "./confirm-reciept.vue?vue&type=style&index=0&id=aca095d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca095d0",
  null
  
)

export default component.exports